import React, { forwardRef, useState } from 'react'

import { cn } from 'src/shared/utils/cn'

import { ImageDialog } from '../image-dialog'

export interface ImageProps extends React.ComponentPropsWithRef<'img'> {
  enableGridDialog?: boolean
  gridImages?: string[]
  initialGridIndex?: number
}

export const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(
  { className, onError, enableGridDialog = false, gridImages, initialGridIndex = 0, ...props },
  ref,
) {
  const [error, setError] = useState(false)
  const [isGridDialogOpen, setIsGridDialogOpen] = useState(false)

  const handleImageClick = () => {
    if (enableGridDialog && gridImages?.length) {
      setIsGridDialogOpen(true)
    }
  }

  return (
    <>
      <img
        {...props}
        className={cn(
          'max-w-full rounded-lg object-cover transition-opacity',
          error && 'opacity-50',
          enableGridDialog && 'cursor-pointer hover:opacity-90',
          className,
        )}
        onError={(e) => {
          setError(true)
          onError?.(e)
        }}
        onClick={handleImageClick}
        ref={ref}
      />
      {enableGridDialog && gridImages && (
        <ImageDialog
          isOpen={isGridDialogOpen}
          onClose={() => setIsGridDialogOpen(false)}
          images={gridImages}
          initialImageIndex={initialGridIndex}
        />
      )}
    </>
  )
})

Image.displayName = 'Image'
